import { render, staticRenderFns } from "./CustomDetailsSelect.vue?vue&type=template&id=ed66236a&scoped=true"
import script from "./CustomDetailsSelect.vue?vue&type=script&lang=js"
export * from "./CustomDetailsSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomDetailsSelect.vue?vue&type=style&index=0&id=ed66236a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed66236a",
  null
  
)

export default component.exports